import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5db611f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "join" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-image" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "brand-text" }, "gence", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-4" }, "Join our waitlist", -1))
const _hoisted_5 = { class: "join-modal mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text secondary mb-1" }, "Your email address", -1))
const _hoisted_7 = { class: "error-text text secondary error mb-4" }
const _hoisted_8 = { class: "terms text secondary" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" By signing up you agree to our ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("terms of service")
const _hoisted_11 = { class: "info-text" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Your information will never be sold and you'll only receive the most pertinent emails. For more information, check out our ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("privacy policy")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "top-bar no-link mb-5"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "alan.turing@gence.io",
        class: _normalizeClass(["mb-1", { error: _ctx.errorMessage }]),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
      }, null, 2), [
        [_vModelText, _ctx.email]
      ]),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1),
      _createElementVNode("button", {
        class: _normalizeClass(["primary wide mb-2", { loading: _ctx.loading }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, " Sign up ", 2),
      _createElementVNode("span", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_router_link, { to: "/terms" }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createVNode(_component_router_link, { to: "privacy" }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }),
      _hoisted_14
    ])
  ]))
}